import errorNotification from "../../Notification/errorNotification";
import { handleStep } from "./handleStep";

export const saveImages = async (
  postmortemState,
  handleSuccess,
  step,
  incidentID,
  setImagesSavedSuccessfully,
  postImage
) => {
  try {
    if (step === 0) {
      await handleStep(
        postmortemState.images.incidentSummary,
        "incidentSummary",
        postmortemState,
        incidentID,
        setImagesSavedSuccessfully,
        postImage
      );
    } else if (step === 1) {
      await handleStep(
        postmortemState.images.rootCause,
        "rootCause",
        postmortemState,
        incidentID,
        setImagesSavedSuccessfully,
        postImage
      );
    } else if (step === 2) {
      await handleStep(
        postmortemState.images.preventiveCorrectiveMeasures,
        "preventiveCorrectiveMeasures",
        postmortemState,
        incidentID,
        setImagesSavedSuccessfully,
        postImage
      );
    } else {
      handleSuccess();
    }
  } catch (error) {
    console.error("ERROR in sending images ", error);
    errorNotification("Error in sending images");
    throw error;
  }
};
